var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.039,
    height: 55.991,
    viewBox: "0 0 49.039 55.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9795",
    "data-name": "Group 9795",
    transform: "translate(-8 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10295",
    "data-name": "Path 10295",
    d: "M40.141,12.377a1,1,0,0,1,.76.1,16.41,16.41,0,0,1,4.92,24,22.22,22.22,0,0,0-4.39,12.42,3.54,3.54,0,0,1,.82,6.43,3.56,3.56,0,0,1-2.88,5.66H26.041a3.55,3.55,0,0,1-3.57-3.57,3.48,3.48,0,0,1,.7-2.09,3.53,3.53,0,0,1,.81-6.43,22.22,22.22,0,0,0-4.39-12.42,16.41,16.41,0,0,1,4.92-24,1,1,0,1,1,1.01,1.73,14.4,14.4,0,0,0-4.33,21.08,24.27,24.27,0,0,1,4.8,13.45h13.43a24.27,24.27,0,0,1,4.8-13.45,14.4,14.4,0,0,0-4.33-21.08,1,1,0,0,1,.25-1.834Zm.26,41.494a1.565,1.565,0,1,0,0-3.13H25.011a1.57,1.57,0,1,0,0,3.13,1,1,0,0,1,.34.07,3.843,3.843,0,0,1,.69-.07,1,1,0,0,1,0,2,1.57,1.57,0,1,0,0,3.13h13.33a1.57,1.57,0,1,0,0-3.13h-6.66a1,1,0,1,1,0-2h6.66a3.26,3.26,0,0,1,.7.07A.879.879,0,0,1,40.4,53.871Z",
    fill: "#030135",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10296",
    "data-name": "Path 10296",
    d: "M31.711,45.918V18.268a3.06,3.06,0,1,1,2,0v27.65a1,1,0,0,1-2,0Zm2.06-30.52a1.06,1.06,0,1,0-1.06,1.06A1.06,1.06,0,0,0,33.771,15.4Z",
    fill: "#030135",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10297",
    "data-name": "Path 10297",
    d: "M39.121,31.5v-2.05a3.05,3.05,0,1,1,2,0v2.88l-3.9,3.9v5.51a1,1,0,0,1-2,0V35.4Zm2.05-4.92a1.05,1.05,0,0,0-1.05-1.05,1,1,0,0,0-1.05,1.05,1.05,1.05,0,1,0,2.1,0Z",
    fill: "#030135",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10298",
    "data-name": "Path 10298",
    d: "M25,32.36a3,3,0,0,1-2-2.87v-.02a3,3,0,1,1,4,2.87v3l3.14,6.28V44.7a1,1,0,0,1-2,0V42.09L25,35.82Zm1.027-3.921A1.05,1.05,0,1,1,25,29.49a1,1,0,0,1,1.027-1.051Z",
    fill: "#030135",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10299",
    "data-name": "Path 10299",
    d: "M32.711,9.52a1,1,0,0,0,1-1V6a1,1,0,0,0-2,0V8.52A1,1,0,0,0,32.711,9.52Z",
    fill: "#030135"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10300",
    "data-name": "Path 10300",
    d: "M11.52,28.141H9a1,1,0,0,0,0,2h2.52a1,1,0,0,0,0-2Z",
    fill: "#030135"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10301",
    "data-name": "Path 10301",
    d: "M56.069,28.141H53.52a1,1,0,0,0,0,2h2.52a1,1,0,0,0,0-2Z",
    fill: "#030135"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10302",
    "data-name": "Path 10302",
    d: "M11.519,14.221a1,1,0,1,0-1.41,1.41l1.78,1.79A1,1,0,1,0,13.3,16Z",
    fill: "#030135"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10303",
    "data-name": "Path 10303",
    d: "M53.661,17.422l1.79-1.79a1,1,0,1,0-1.42-1.41L52.251,16a1,1,0,0,0,1.41,1.42Z",
    fill: "#030135"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIcon4);
export default __webpack_public_path__ + "static/media/box-icon-4.e34901e51790d4f01ca6a15f976fdccb.svg";
export { ForwardRef as ReactComponent };